import { apiAxios } from '@app/api-client';
import type { ModuleDto } from '@app/contracts';

export const fetchAllModules = (): Promise<ModuleDto[]> =>
  apiAxios<ModuleDto[]>({ url: '/api/v1/modules', method: 'GET' });

export const fetchSiteModules = (siteId: string): Promise<ModuleDto[]> =>
  apiAxios<ModuleDto[]>({ url: `/api/v1/sites/${siteId}/modules`, method: 'GET' });

export const assignModule = (siteId: string, moduleId: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/sites/${siteId}/modules/${moduleId}`, method: 'POST' });

export const unassignModule = (siteId: string, moduleId: string): Promise<void> =>
  apiAxios<void>({ url: `/api/v1/sites/${siteId}/modules/${moduleId}`, method: 'DELETE' });
